import {Directive} from '@angular/core'

@Directive({selector: '[click-to-edit-view]'})
export class ClickToEditView {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/click-to-edit/click.to.edit.view.directive.ts